<template>
  <div id="company-display-available-awards" class="col">
    <div class="row-12">
      <h6 class="mb-0 mt-1 mt-sm-0 mt-md-1 mt-lg-2 font-weight-bold text-nowrap text-medium">Awards</h6>
      <div class="sep-small mb-4 mb-md-3" />
    </div>
    <div id="award-list" class="row-12 d-flex flex-wrap">
      <div v-if="!awards || (awards && awards.length < 1)" class="pb-4">No awards available at this time</div>
      <template v-for="(award, index) in awards" v-else>
        <div v-if="!award.deleted_at" :key="award.name + index" class="award-item mr-3 mb-3">
          <img :id="award.name + award.id + index" :src="award.logoLink" :alt="award.name" class="img-fluid" />
          <BTooltip :target="award.name + award.id + index" triggers="hover">
            {{ award.name }}
          </BTooltip>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    awards: { type: Array, required: true },
  },
};
</script>

<style lang="scss" scoped>
#company-display-available-awards {
  min-width: 15rem;
  #award-list {
    .award-item {
      display: flex;
      flex-direction: column;
      text-align: center;
      width: 50px;

      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
